import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const NotFound = Loadable(lazy(() => import('./NotFound')));
const ForgotPassword = Loadable(lazy(() => import('./ForgotPassword')));
const JwtLogin = Loadable(lazy(() => import('./JwtLogin')));
const ChatStart = Loadable(lazy(() => import('./chatStart')));
const CompanyDiscovery = Loadable(lazy(() => import('../services/CompanyDiscovery')));
const NewProfile = Loadable(lazy(() => import('./Profile.jsx')));
const ResetPassword = Loadable(lazy(() => import('./ResetPassword')));

const sessionRoutes = [
  { path: '/session/signup', element: <CompanyDiscovery /> },
  { path: '/login', element: <JwtLogin /> },
  { path: '/session/signin', element: <Navigate replace to="/login" /> },
  { path: '/session/chatStart', element: <ChatStart /> },
  { path: '/session/forgot-password', element: <ForgotPassword /> },
  { path: '/session/reset-password', element: <ResetPassword /> },
  { path: '/session/new-profile', element: <NewProfile /> },
  { path: '/session/404', element: <NotFound /> },
  { path: '/', element: <Navigate replace to="/login" /> },
];

export default sessionRoutes;
